<script>
import axios from "axios";
import appConfig from "@/app.config";
export default {
  page: {
    title: "Login ",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      username: "",
      password: "",
      error:'',
      loader:false,
      today: new Date().toLocaleDateString('fr-CA'),
      showPassword: false,
      activeTestimonial: 0,
      testimonials: [
        {
          text: "The Afrimed Software handles all our medical departments seamlessly. We've successfully digitalized all our services. Highly recommended!",
          author: "Shakira N",
          role: "Medical Director, Stana Medical Center"
        },
        {
          text: "An excellent solution for modern healthcare management. The system is intuitive and powerful.",
          author: "Dr. James K",
          role: "Chief Medical Officer, Health Plus Clinic"
        },
        {
          text: "Implementation was smooth and support team is always responsive. Our hospital operations are now 40% more efficient.",
          author: "Sarah M",
          role: "Hospital Administrator"
        }
      ],
      autoRotateInterval: null
    };
  },
  methods: {
    async login() { 
      this.loader=true;
      let formData = new FormData();
      formData.append("username", this.username);
      formData.append("password", this.password);
      let url = "/login";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          let userData=response.data.user;
          let token=response.data.token;
          let license=response.data.license;
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          localStorage.setItem('user', JSON.stringify(userData))
          localStorage.setItem('token',token);
          localStorage.setItem('license',license);
          if (new Date(license) <= new Date(this.today)) {
            this.$router.push(this.$route.query.redirectFrom || {name: "license-expired",});
          } else {
            this.$router.push(this.$route.query.redirectFrom || {name: "default",})          
          }
        } else {
          this.error=response.data.message;
          this.loader=false;
        }
      })
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      const passwordInput = document.getElementById('password');
      if (passwordInput) {
        passwordInput.type = this.showPassword ? 'text' : 'password';
      }
    },
    nextTestimonial() {
      this.activeTestimonial = (this.activeTestimonial + 1) % this.testimonials.length;
      this.resetAutoRotate();
    },
    prevTestimonial() {
      this.activeTestimonial = (this.activeTestimonial - 1 + this.testimonials.length) % this.testimonials.length;
      this.resetAutoRotate();
    },
    goToTestimonial(index) {
      this.activeTestimonial = index;
      this.resetAutoRotate();
    },
    startAutoRotate() {
      this.autoRotateInterval = setInterval(() => {
        this.activeTestimonial = (this.activeTestimonial + 1) % this.testimonials.length;
      }, 5000);
    },
    resetAutoRotate() {
      if (this.autoRotateInterval) {
        clearInterval(this.autoRotateInterval);
      }
      this.startAutoRotate();
    },
    handleMouseEnter() {
      if (this.autoRotateInterval) {
        clearInterval(this.autoRotateInterval);
      }
    },
    handleMouseLeave() {
      this.startAutoRotate();
    }
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
    this.startAutoRotate();
  },
  beforeUnmount() {
    if (this.autoRotateInterval) {
      clearInterval(this.autoRotateInterval);
    }
  }
};
</script>

<template>
  <div class="auth-container">
    <div class="auth-wrapper">
      <!-- Left Panel - Modern Design -->
      <div class="auth-left-panel d-lg-flex d-none">
        <div class="auth-left-overlay"></div>
        <div class="auth-left-content">
          <!-- Logo Section -->
          

          <!-- Testimonials Section -->
          <div class="testimonials-section">
            <div class="section-header">
              <div class="quote-icon">
                <i class="bx bxs-quote-alt-left"></i>
              </div>
              <h3>Trusted by <span class="highlight">Healthcare Professionals</span></h3>
            </div>
            
            <!-- Custom Carousel -->
            <div 
              class="custom-carousel"
              @mouseenter="handleMouseEnter"
              @mouseleave="handleMouseLeave"
            >
              <!-- Testimonial Content -->
              <div class="carousel-inner">
                <transition name="fade" mode="out-in">
                  <div 
                    :key="activeTestimonial" 
                    class="carousel-item"
                  >
                    <div class="testimonial-item">
                      <div class="testimonial-content">
                        <p class="testimonial-text">
                          {{ testimonials[activeTestimonial].text }}
                        </p>
                        <div class="testimonial-author">
                          <div class="author-avatar">
                            <div class="avatar-initials">
                              {{ testimonials[activeTestimonial].author.charAt(0) }}
                            </div>
                          </div>
                          <div class="author-info">
                            <h5>{{ testimonials[activeTestimonial].author }}</h5>
                            <p>{{ testimonials[activeTestimonial].role }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>

              <!-- Carousel Controls -->
              <div class="carousel-controls">
                <button 
                  class="carousel-control prev" 
                  @click="prevTestimonial"
                  aria-label="Previous testimonial"
                >
                  <i class="mdi mdi-chevron-left"></i>
                </button>
                
                <!-- Indicators -->
                <div class="carousel-indicators">
                  <button
                    v-for="(testimonial, index) in testimonials"
                    :key="index"
                    :class="['indicator', { active: activeTestimonial === index }]"
                    @click="goToTestimonial(index)"
                    :aria-label="`Go to testimonial ${index + 1}`"
                  />
                </div>
                
                <button 
                  class="carousel-control next" 
                  @click="nextTestimonial"
                  aria-label="Next testimonial"
                >
                  <i class="mdi mdi-chevron-right"></i>
                </button>
              </div>
            </div>

            <!-- Stats Section -->
            <div class="stats-section">
              <div class="stat-item">
                <div class="stat-icon">
                  <i class="mdi mdi-hospital-building"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-number">50+</div>
                  <div class="stat-label">Healthcare Facilities</div>
                </div>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-item">
                <div class="stat-icon">
                  <i class="mdi mdi-account-check"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-number">99%</div>
                  <div class="stat-label">Satisfaction Rate</div>
                </div>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-item">
                <div class="stat-icon">
                  <i class="mdi mdi-headset"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-number">24/7</div>
                  <div class="stat-label">Support</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="auth-right-panel ">
        <div class="auth-form-container">
          <div class="form-header">
            <div class="brand-section">
            <div class="logo-wrapper">
              <img 
                src="@/assets/images/logo.png" 
                alt="Afrimed Logo" 
                class="brand-logo"
              />
            </div>
            <h1 class="brand-title">Afrimed</h1>
            <p class="brand-subtitle">Health Management Software</p>
            <p class="welcome-subtitle">Sign in to your account</p>
            </div>
          </div>

          <!-- Error Alert -->
          <transition name="slide-down">
            <div 
              v-if="error" 
              class="error-alert"
            >
              <div class="alert-icon">
                <i class="mdi mdi-alert-circle-outline"></i>
              </div>
              <div class="alert-content">
                <p class="alert-message">{{ error }}</p>
              </div>
              <button 
                @click="error = ''" 
                class="alert-close"
              >
                <i class="mdi mdi-close"></i>
              </button>
            </div>
          </transition>

          <!-- Login Form -->
          <div class="form-wrapper">
            <form @submit.prevent="login" class="login-form">
              <!-- Username Field -->
              <div class="form-group">
                <label for="username" class="form-label">
                  <i class="mdi mdi-account-outline"></i>
                  Username
                </label>
                <div class="input-with-icon">
                  <i class="input-icon mdi mdi-account"></i>
                  <input 
                    id="username" 
                    v-model="username" 
                    required
                    type="text" 
                    placeholder="Enter your username"
                    class="modern-input"
                  />
                </div>
              </div>

              <!-- Password Field -->
              <div class="form-group">
                <label for="password" class="form-label">
                  <i class="mdi mdi-lock-outline"></i>
                  Password
                </label>
                <div class="input-with-icon">
                  <i class="input-icon mdi mdi-lock"></i>
                  <input 
                    id="password" 
                    v-model="password" 
                    required
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="Enter your password"
                    class="modern-input"
                  />
                  <button 
                    type="button" 
                    class="password-toggle"
                    @click="togglePasswordVisibility"
                  >
                    <i :class="['mdi', showPassword ? 'mdi-eye-off' : 'mdi-eye']"></i>
                  </button>
                </div>
              </div>

              <div class="form-options">
                <div class="remember-me">
                  <input type="checkbox" id="remember-me" class="custom-checkbox"/>
                  <label for="remember-me">Remember me</label>
                </div>
                <a href="#" class="forgot-password">Forgot password?</a>
              </div>

              <button 
                type="submit" 
                class="submit-button"
                :disabled="loader"
              >
                <span v-if="!loader">
                  <i class="mdi mdi-login"></i>
                  Sign In
                </span>
                <span v-else class="loading-state">
                  <div class="spinner"></div>
                  Signing In...
                </span>
              </button>
             
            </form>

            <!-- Footer -->
            <div class="form-footer">
              <p class="copyright">
                <i class="mdi mdi-shield-check"></i>
                A product of 
                <a 
                  href="https://tandikatechnologies.com/" 
                  target="_blank" 
                  class="company-link"
                >
                  Tandika Technologies
                </a>
              </p>
              <p class="copyright-text">
                © {{ new Date().getFullYear() }} Afrimed. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.auth-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.auth-wrapper {
  display: flex;
  min-height: 100vh;
}

/* Left Panel Styles */
.auth-left-panel {
  flex: 1;
  background: #03967d;
  position: relative;
  overflow: hidden;
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-left-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.05) 100%);
  z-index: 1;
}

.auth-left-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  width: 100%;
  color: white;
  animation: slideInLeft 0.8s ease-out;
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.brand-section {
  text-align: center;
}

.logo-wrapper {
  display: inline-block;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.brand-logo {
  width: 100px;
  height: 100px;
  margin-top: -2rem;
  object-fit: contain;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.2));
}

.brand-title {
  font-size: 2.0rem;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 0.2rem;
  color: rgb(22, 23, 22);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: -0.5px;
}

.brand-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
  color: rgba(18, 15, 15, 0.9);
  font-weight: 400;
}

.testimonials-section {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 2.5rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.section-header {
  text-align: center;
}

.quote-icon {
  font-size: 3.5rem;
  opacity: 0.2;
  margin-bottom: 1rem;
  color: white;
}

.section-header h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: white;
}

.highlight {
  color: #ffd700;
  font-weight: 800;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Custom Carousel */
.custom-carousel {
  margin-top: -10px;
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  cursor: grab;
  
  &:active {
    cursor: grabbing;
  }
}

.carousel-inner {
  position: relative;
  overflow: hidden;
  min-height: 160px;
}

.carousel-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Fade Transition */
.fade-enter-active {
  animation: fadeIn 0.5s ease forwards;
}

.fade-leave-active {
  animation: fadeOut 0.5s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-20px);
  }
}

.testimonial-item {
  padding: 1rem;
  width: 100%;
}

.testimonial-content {
  text-align: center;
}

.testimonial-text {
  font-size: 1rem;
  line-height: 1;
  font-style: italic;
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  padding: 0 0.5rem;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.testimonial-author {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -10px;
  gap: 1rem;
}

.author-avatar {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #03967d 0%, #34c38f 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
  border: 3px solid rgba(255, 255, 255, 0.3);
}

.avatar-initials {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
}

.author-info {
  text-align: left;
}

.author-info h5 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}

.author-info p {
  margin: 0;
  opacity: 0.85;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
}

/* Carousel Controls */
.carousel-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2.5rem;
  padding: 0 1rem;
}

.carousel-control {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.5rem;
  
  &:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
}

.carousel-indicators {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  
  &.active {
    width: 28px;
    border-radius: 15px;
    background: white;
    transform: scale(1.1);
  }
  
  &:hover:not(.active) {
    background: rgba(255, 255, 255, 0.5);
    transform: scale(1.2);
  }
}

/* Stats Section */
.stats-section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-align: left;
}

.stat-icon {
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
  margin-bottom: 0.1rem;
  line-height: 1;
}

.stat-label {
  font-size: 0.8rem;
  opacity: 0.9;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
}

.stat-divider {
  width: 1px;
  height: 30px;
  background: rgba(255, 255, 255, 0.2);
}

/* Right Panel Styles */
.auth-right-panel {
  flex: 0 0 500px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  position: relative;
}

.auth-form-container {
  max-width: 400px;
  width: 100%;
  animation: slideInRight 0.8s ease-out;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Form Header */
.form-header {
  margin-bottom: 2.5rem;
}

.welcome-title {
  font-size: 2.2rem;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 0.2rem;
  letter-spacing: -0.5px;
}

.welcome-subtitle {
  margin-top: -0.3rem;
  color: #666;
  font-size: 0.8rem;
  font-weight: 400;
}

/* Error Alert */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.error-alert {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  color: white;
  border-radius: 16px;
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  box-shadow: 0 8px 20px rgba(238, 90, 82, 0.2);
  animation: shake 0.5s ease;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

.alert-icon {
  font-size: 1.75rem;
  flex-shrink: 0;
}

.alert-content {
  flex: 1;
}

.alert-message {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
}

.alert-close {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  opacity: 0.8;
  transition: all 0.3s ease;
  padding: 0.5rem;
  border-radius: 8px;
  flex-shrink: 0;
  
  &:hover {
    opacity: 1;
    background: rgba(255, 255, 255, 0.1);
  }
}

/* Form Styles */
.form-wrapper {
  margin-top: -20px;
  background: white;
}

.form-group {
  margin-bottom: 0.5rem;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 0.2rem;
  font-size: 0.95rem;
}

.input-with-icon {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 1.25rem;
  color: #666;
  font-size: 1.25rem;
  z-index: 1;
}

.modern-input {
  width: 100%;
  padding: 0.8rem 0.5rem 0.8rem 3.25rem;
  border: 2px solid #e1e5e9;
  border-radius: 40px;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #f8fafc;
  color: #1a1a1a;
  
  &:focus {
    outline: none;
    border-color: #03967d;
    background: white;
    box-shadow: 0 0 0 4px rgba(85, 110, 230, 0.15);
  }
  
  &::placeholder {
    color: #94a3b8;
    font-weight: 400;
  }
}

.password-toggle {
  position: absolute;
  right: 1.25rem;
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 0.5rem;
  transition: all 0.3s ease;
  border-radius: 8px;
  font-size: 1.25rem;
  
  &:hover {
    color: #03967d;
    background: #f1f5f9;
  }
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.custom-checkbox {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 2px solid #cbd5e1;
  appearance: none;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  
  &:checked {
    background: #03967d;
    border-color: #03967d;
    
    &::after {
      content: '✓';
      position: absolute;
      color: white;
      font-size: 14px;
      font-weight: bold;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  
  &:hover {
    border-color: #03967d;
  }
}

.remember-me label {
  color: #475569;
  font-weight: 500;
  cursor: pointer;
  font-size: 0.95rem;
}

.forgot-password {
  color: #03967d;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all 0.3s ease;
  
  &:hover {
    color: #03967d;
    text-decoration: underline;
  }
}

.submit-button {
  width: 100%;
  padding: 0.8rem;
  background: linear-gradient(135deg, #03967d 0%, #03967d 100%);
  color: white;
  border: none;
  border-radius: 44px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  letter-spacing: 0.5px;
  
  &:hover:not(:disabled) {
    transform: translateY(-3px);
    box-shadow: 0 12px 24px rgba(85, 110, 230, 0.3);
  }
  
  &:active:not(:disabled) {
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: none !important;
  }
}

.loading-state {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.form-footer {
  text-align: center;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.copyright {
  color: #64748b;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-weight: 500;
}

.company-link {
  color: #03967d;
  text-decoration: none;
  font-weight: 700;
  transition: all 0.3s ease;
  
  &:hover {
    color: #03967d;
    text-decoration: underline;
  }
}

.copyright-text {
  color: #94a3b8;
  font-size: 0.85rem;
  margin: 0;
  font-weight: 400;
}

/* Progress Bar for Auto Rotation */
.auto-rotate-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: rgba(255, 255, 255, 0.5);
  width: 100%;
  overflow: hidden;
  border-radius: 0 0 16px 16px;
}

.progress-bar {
  height: 100%;
  background: white;
  animation: progress 5s linear infinite;
}

@keyframes progress {
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
}

/* Responsive Design */
@media (max-width: 1200px) {
  .auth-right-panel {
    flex: 0 0 450px;
  }
}

@media (max-width: 1024px) {
  .auth-wrapper {
    flex-direction: column;
  }
  
  .auth-left-panel {
    min-height: 500px;
  }
  
  .auth-right-panel {
    flex: 1;
    min-height: calc(100vh - 500px);
    padding: 3rem 2rem;
  }
  
  .auth-form-container {
    max-width: 450px;
  }
}

@media (max-width: 768px) {
  .auth-left-panel {
    padding: 1.5rem;
    min-height: 450px;
  }
  
  .auth-right-panel {
    padding: 2rem 1.5rem;
  }
  
  .brand-logo {
    width: 100px;
    height: 100px;
  }
  
  .brand-title {
    font-size: 2rem;
  }
  
  .testimonials-section {
    padding: 2rem;
  }
  
  .testimonial-text {
    font-size: 1.05rem;
    padding: 0;
  }
  
  .stats-section {
    flex-direction: column;
    gap: 2rem;
    padding-top: 2rem;
  }
  
  .stat-divider {
    width: 100px;
    height: 1px;
  }
  
  .stat-item {
    justify-content: center;
    width: 100%;
  }
  
  .social-login {
    grid-template-columns: 1fr;
  }
  
  .welcome-title {
    font-size: 1.875rem;
  }
}

@media (max-width: 480px) {
  .auth-left-panel,
  .auth-right-panel {
    padding: 1.25rem;
  }
  
  .brand-title {
    font-size: 1.75rem;
  }
  
  .brand-subtitle {
    font-size: 1rem;
  }
  
  .section-header h3 {
    font-size: 1.5rem;
  }
  
  .testimonial-text {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
  
  .carousel-controls {
    padding: 0;
  }
  
  .form-options {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  
  .copyright {
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>